import { ChangeDetectorRef, Component, HostListener, Input, OnInit } from '@angular/core';
import { EmployeeApplicationFormComponent } from '../employee-application-form/employee-application-form.component';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { HttpService } from 'src/app/service/http/http.service';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { AddElcmCandidateComponent } from '../add-elcm-candidate/add-elcm-candidate.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ConvertElcmPopupComponent } from '../convert-elcm-popup/convert-elcm-popup.component';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { GenerateOfferLaterComponent } from '../elcm/generate-offer-later/generate-offer-later.component';
import { finalize, of, switchMap, tap } from 'rxjs';
import { formatText } from 'src/app/shared/commen-function-file';
import { OfferLetterPreviewComponent } from '../offer-letter-preview/offer-letter-preview.component';
import { ElcmGenericServiceService } from '../_elcm-services/elcm-generic-service.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

@Component({
  selector: 'app-offer-and-appointment',
  templateUrl: './offer-and-appointment.component.html',
  styleUrls: ['./offer-and-appointment.component.scss'],
})
export class OfferAndAppointmentComponent implements OnInit {
  buttonColorName: any;
  loggedInUserRole: any;
  loggedInUserId: any | null;
  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any;
  setupNotCompleted: any;

  @Input() chechsetupStatus: any;
  formatedataVariable = formatText;
  constructor(private datePipe: DatePipe,

    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,
    private cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<OfferAndAppointmentComponent>,
    private elcmGenericService: ElcmGenericServiceService,
    public mobileResponsiveService: MobileResponsiveService
  ) {

  }

  ngOnInit() {


    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId') || null;
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    // this.setupNotCompleted = this.httpService.notcompletedElcmSetUp




    this.getEmployeeList();
    // ✅ Force change detection
    this.cdRef.detectChanges();

  }

  isSetupIncomplete: boolean = false;


  OfferAndAppointmentTableHeader: any = [
    { label: "Sr.No" },
    { label: "Salutation" },
    { label: "First Name" },
    { label: "Last Name" },
    { label: "Personal Email Id" },
    { label: "Status" },
    { label: "Action" }
  ]

  employees: any = []
  appointment: any;
  searchTerm: string = ''; // Holds search input value
  filteredEmployees: any[] = []; // Holds filtered employee list
  getEmployeeList() {
    this.httpService.callGetService(`${this.config.employeeList}/${this.loggedInUserCompanyID}`).subscribe((record: any) => {
      this.appointment = this.httpService.selectedOptionForAppoinmentLetter
      console.log(this.appointment);
      setTimeout(() => {
        this.appointment = this.httpService.selectedOptionForAppoinmentLetter
        console.log(this.appointment);
      }, 100)
      console.log(record.data);
      
      this.filteredEmployees = record.data;

      if (this.loggedInUserRole === 'Admin') this.filteredEmployees = this.elcmGenericService.empFilterForAllEmployeeList(this.filteredEmployees, Number(this.loggedInUserId), 'hrId', true);

      this.employees = this.filteredEmployees; // Initialize filtered list
    })
  }
  // Filter employees based on search input
  filterEmployees() {
    this.employees = this.filteredEmployees.filter((emp: any) =>
      emp?.firstName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      emp?.lastName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      emp?.salutation?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      emp?.status?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      emp?.candidateEmail?.toLowerCase().includes(this.searchTerm.toLowerCase())  // Adjust keys based on API response
    );
    console.log(this.employees);

  }
selectedSize:any=25;
  DislaySelectedRecord(event: any) {
    this.selectedSize=event.value;
    this.employees = this.filteredEmployees.slice(0, event.value);

  }




  downloadEmployeeList() {
    if (!this.employees || this.employees.length === 0) {
      console.warn('No data available for export');
      return;
    }

    // Extract only the required fields
    const filteredData = this.employees.map((employee: any) => ({
      Salutation: employee.salutation,
      FirstName: employee.firstName,
      LastName: employee.lastName,
      "Personal Email Id": employee.candidateEmail, // Fixed key with quotes
      Status: this.formatedataVariable(employee.status)
    }));

    // Convert to Excel format
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook: XLSX.WorkBook = { Sheets: { 'Employees': worksheet }, SheetNames: ['Employees'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Convert to Blob and trigger download
    const data: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(data, 'Employee_List.xlsx');
  }
  selectedEmployeeId: any;
  checkCloseValue: any;
  updatedCandidateIds: any = []
  employeeApplicationForm(candidateDetails: any) {

    if(this.mobileResponsiveService.hideForTabletAndBelow) return;

    this.checkSendOfferLetterFlag = true
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%'; // Adjust as needed
    dialogConfig.width = '100%'; // Adjust as needed
    dialogConfig.disableClose = true; // Prevent closing via ESC or outside click
    dialogConfig.data = {
      popupName: 'Employee Application',

      candidateId: candidateDetails,

    };
    dialogConfig.panelClass = 'custom-dialog-container';

    const dialogRef = this.dialog?.open(EmployeeApplicationFormComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      this.checkCloseValue = result
      if (result) {
        // this.selectedEmployeeId = candidateDetails.candidateId;
        const updatedId = candidateDetails.candidateId;

        if (!this.updatedCandidateIds.includes(updatedId)) {
          this.updatedCandidateIds.push(updatedId);
          sessionStorage.setItem('updatedCandidateIds', JSON.stringify(this.updatedCandidateIds));
        }
        this.getEmployeeList();
      } else {
        // // Optional: reset if not updated
        // this.selectedEmployeeId = null;
        this.getEmployeeList();
      }
      // Perform actions based on result


    });
  }
  convertEmployeeCode(candidateDetails: any) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    // dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.width= window.innerWidth <= 576 ? '100%' : '80%';
    dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      candidateData: candidateDetails,
      allCandidateList: this.employees,
    };

    const dialogRef = this.dialog.open(ConvertElcmPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(() => {
      this.getEmployeeList();

    });
  }

  addCandidate() {

    if (this.setupNotCompleted) {
      const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        // width: '20%',
        width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
        maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
        data: {
          msg: 'Set up not completed',
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        }
      });
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.height = '70%';
    // dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.width= window.innerWidth <= 576 ? '100%' : '80%';
    dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {

    };

    const dialogRef = this.dialog.open(AddElcmCandidateComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getEmployeeList();

    });



  }

  offerLetterPriview(event: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.height = '90%';
    // dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.width= window.innerWidth <= 576 ? '100%' : '80%';
    dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      candidateID: event
    };

    const dialogRef = this.dialog.open(OfferLetterPreviewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });
  }
  // viewOferLatter(employee: any) {
  //   let formData = {
  //     "candidateId": employee.candidateId,
  //     "hrEmail": employee.candidateEmail,
  //     "companyId": this.loggedInUserCompanyID,
  //     "isAppointmentletter": "NO",
  //     "year": employee.year
  //   }

  //   console.log(employee.fileName);
  //   if (employee.fileName == null || employee.fileName == "") {
  //     this.httpService.callPostService(`${this.config.viewOfferLetter}`, formData).subscribe((record: any) => {
  //       if (record) {
  //         // Assign fileName from API response
  //         employee.fileName = record.fileName; 
  //         if (this.httpService.selectedOptionSalaryBreakUp){

  //           this.httpService.callPostService(`${this.config.updateSalaryBreckup}`, formData).subscribe((record: any) => {
  //             this.getEmployeeList();
  //            setTimeout(()=>{
  //            let filenameData=this.employees.filter((elm:any)=>elm.candidateId==employee.candidateId)
  //             console.log(filenameData);

  //             // Ensure fileName is set before calling viewDocument
  //             if (filenameData) {
  //               console.log(filenameData[0].fileName);

  //               this.viewDocument(filenameData[0].fileName)
  //             } else {
  //               console.error("File name is missing in API response");
  //             }
  //            },200)
  //           });
  //         }else{
  //           this.getEmployeeList();
  //           setTimeout(()=>{
  //           let filenameData=this.employees.filter((elm:any)=>elm.candidateId==employee.candidateId)
  //            console.log(filenameData);

  //            // Ensure fileName is set before calling viewDocument
  //            if (filenameData) {
  //              console.log(filenameData[0].fileName);

  //              this.viewDocument(filenameData[0].fileName)
  //            } else {
  //              console.error("File name is missing in API response");
  //            }
  //           },200)
  //         }
  //       }
  //     });
  //   } else {
  //     console.log(employee.fileName);
  //     this.viewDocument(employee.fileName);
  //   }



  // }

  isLoading = false; // Add this flag at the component level

  viewOferLatter(employee: any) {
    console.log(employee.candidateId);
    console.log(this.selectedEmployeeId);

    if (this.isLoading) {
      console.warn("Request already in progress. Please wait.");
      return; // Prevent further execution if request is pending
    }

    this.isLoading = true; // Set flag to true before API call

    let formData = {
      "candidateId": employee.candidateId,
      "hrEmail": employee.hrMail,
      "companyId": this.loggedInUserCompanyID,
      "isAppointmentletter": "NO",
      "year": employee.year
    };




    // if (!employee.fileName) {
    this.httpService.callPostService(`${this.config.viewOfferLetter}`, formData).subscribe({
      next: (record: any) => {
        if (record) {
          // employee.fileName = record.fileName;

          const updateSalaryBreakup = () => {
            this.getEmployeeList();
            setTimeout(() => {
          
              let filenameData = this.employees.find((elm: any) => elm.candidateId == employee.candidateId);
              
              if (filenameData?.fileName ||record.fileName) {
                console.log(filenameData.fileName);
                this.viewDocument(filenameData.fileName ||record.fileName);
              } else {
                console.error("File name is missing in API response");
              }
            }, 200);
          };
          const callTeamAndConditionApis = () => {


            this.httpService.callPostService(`${this.config.termsconditionApi}`, formData).subscribe({
              next: (res) => {
                console.log("Condition API Response:", res);
                updateSalaryBreakup();

              },
              error: (err) => {
                console.error("Error calling Condition API:", err);
              }
            });
          };
          if (this.httpService.selectedOptionSalaryBreakUp) {
            this.httpService.callPostService(`${this.config.updateSalaryBreckup}`, formData).subscribe({
              next: () => {

                callTeamAndConditionApis(); // Call after salary breakup update
              },
              error: (err) => console.error("Error updating salary breakup:", err),
              complete: () => (this.isLoading = false)
            });
          } else {
            callTeamAndConditionApis();


            this.isLoading = false;
          }
        }
      },
      error: (error) => {

        const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          // width: '30%',
          width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
          maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
          data: {
            msg: error.error.message,
            btn2: 'OK',
            btn2BgColor: 'red', // Highlight error with red button color
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });
        errorDialogRef.afterClosed().subscribe(() => {
          // Optionally handle any action after closing the error dialog
          console.log('Error dialog closed');
        });
        this.isLoading = false;
      },
      complete: () => (this.isLoading = false)
    });
    // } else {
    //   console.log(employee.fileName);
    //   this.viewDocument(employee.fileName);
    //   this.isLoading = false;
    // }
  }


  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }




  }
  checkSendOfferLetterFlag: boolean = false;
  isSendingOfferLetter: boolean = false;
  // sendOferLatter(employee: any) {
  //   if (this.isSendingOfferLetter) {
  //   return; // 🚫 Block duplicate clicks while API is running
  // }

  // this.isSendingOfferLetter = true; // ⏳ Start loader


  //   let formData = {
  //     "candidateId": employee.candidateId,
  //     "hrEmail": employee.hrMail,
  //     "isAppointmentletter": "NO",
  //     "companyId": this.loggedInUserCompanyID,
  //     "year": employee.year
  //   }
  //   this.httpService.callPostService(`${this.config.sendOfferLetter}`, formData).subscribe((record: any) => {
  //     if (record) {
  //       // Success popup
  //       const sentId = record.data.data;
  //       console.log(sentId);

  //       const index = this.updatedCandidateIds.indexOf(sentId);
  //       if (index !== -1) {
  //         this.updatedCandidateIds.splice(index, 1); // remove the existing entry
  //       }

  //       console.log(this.updatedCandidateIds);

  //       const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //         disableClose: true,
  //         height: '25%',
  //         width: '30%',
  //         data: {
  //           msg: record.message,
  //           btn2: 'OK',
  //           btn2BgColor: this.buttonColorName,
  //           showSuccessIcon: true,
  //           showSuccessMessage: false,
  //           showCloseIcon: false
  //         }
  //       });

  //       // Handle the result of the dialog
  //       dialogRef.afterClosed().subscribe(() => {
  //         this.dialogRef.close();
  //         this.getEmployeeList();

  //       });
  //       this.getEmployeeList();
  //       this.checkSendOfferLetterFlag = false
  //       this.selectedEmployeeId = null;
  //     }
  //   },
  //     (error: any) => {

  //       const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //         disableClose: true,
  //         height: '25%',
  //         width: '30%',
  //         data: {
  //           msg: error.error.message || 'An error occurred while processing your request. Please try again.',
  //           btn2: 'OK',
  //           btn2BgColor: 'red', // Highlight error with red button color
  //           showSuccessIcon: false,
  //           showSuccessMessage: false,
  //           showCloseIcon: false
  //         }
  //       });

  //       errorDialogRef.afterClosed().subscribe(() => {
  //         // Optionally handle any action after closing the error dialog
  //         console.log('Error dialog closed');
  //       });
  //     }

  //   );


  // }

  loadingCandidateId: Set<string> = new Set();

  sendOfferLetter(employee: any) {
    // ✅ Show loader for this row
    this.loadingCandidateId.add(employee.candidateId);

    const formData = {
      candidateId: employee.candidateId,
      hrEmail: employee.hrMail,
      isAppointmentletter: "NO",
      companyId: this.loggedInUserCompanyID,
      year: employee.year
    };

    this.httpService.callPostService(`${this.config.sendOfferLetter}`, formData)
      .pipe(
        finalize(() => {
          // ✅ Always clear loader after request finishes
          this.loadingCandidateId.delete(employee.candidateId);
        })
      )
      .subscribe({
        next: (record: any) => {
          if (record) {
            // const sentId = record.data.data;
            // const index = this.updatedCandidateIds.indexOf(sentId);
            // if (index !== -1) this.updatedCandidateIds.splice(index, 1);
            const sentId = record.data.data;
            const index = this.updatedCandidateIds.indexOf(sentId);

            if (index !== -1) {
              this.updatedCandidateIds.splice(index, 1);

              // Update sessionStorage
              sessionStorage.setItem('updatedCandidateIds', JSON.stringify(this.updatedCandidateIds));
            }

            const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              // width: '30%',
              width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: record.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });

            dialogRef.afterClosed().subscribe(() => {
              this.dialogRef.close();
              this.getEmployeeList();
            });

            this.getEmployeeList();
            this.checkSendOfferLetterFlag = false;
            this.selectedEmployeeId = null;
          }
        },
        error: (error: any) => {
          this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            // width: '30%',
            width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
            maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
            data: {
              msg: error.error.message || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red',
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
        }
      });
  }




  isDisabledToSendOffer(employee: any): boolean {
     const storedIds = sessionStorage.getItem('updatedCandidateIds');
  this.updatedCandidateIds = storedIds ? JSON.parse(storedIds) : [];
    return (
      employee.fileName == null ||
      (employee.status === 'OFFER_LETTER_SENT' && !this.updatedCandidateIds.includes(employee.candidateId)) ||
      employee.status === 'APPROVED_APPOINTMENT_LETTER'
    );
  }


}


